/**
 * Keyboard navigation for expense grid tables.
 * Supports Enter, ArrowDown, ArrowUp, ArrowLeft, ArrowRight.
 *
 * Works with both raw <input data-row data-col> and <td data-row data-col> > <input> (el-input).
 */
export function handleGridKeydown(event, containerEl) {
  const target = event.target;
  if (!target || target.tagName !== 'INPUT') return;

  let row, col;
  if (target.dataset.row !== undefined && target.dataset.col !== undefined) {
    row = parseInt(target.dataset.row);
    col = parseInt(target.dataset.col);
  } else {
    const cell = target.closest('td[data-row][data-col]');
    if (!cell) return;
    row = parseInt(cell.dataset.row);
    col = parseInt(cell.dataset.col);
  }
  if (isNaN(row) || isNaN(col)) return;

  let newRow = row;
  let newCol = col;

  const selStart = target.selectionStart ?? 0;
  const selEnd = target.selectionStart ?? target.value.length;

  switch (event.key) {
    case 'Enter':
    case 'ArrowDown':
      newRow = row + 1;
      event.preventDefault();
      break;
    case 'ArrowUp':
      newRow = row - 1;
      event.preventDefault();
      break;
    case 'ArrowRight':
      if (selEnd === target.value.length) {
        newCol = col + 1;
        event.preventDefault();
      } else return;
      break;
    case 'ArrowLeft':
      if (selStart === 0) {
        newCol = col - 1;
        event.preventDefault();
      } else return;
      break;
    default:
      return;
  }

  if (newRow < 0 || newCol < 0) return;

  let nextInput = containerEl.querySelector(`input[data-row="${newRow}"][data-col="${newCol}"]`);
  if (!nextInput) {
    const nextCell = containerEl.querySelector(`td[data-row="${newRow}"][data-col="${newCol}"]`);
    if (nextCell) {
      nextInput = nextCell.querySelector('input');
    }
  }
  if (nextInput) {
    nextInput.focus();
    nextInput.select();
  }
}
